/**
 * 日を加算/減算
 */
export function addDaysToDate(date: Date, addDays: number): Date {
  const newDate = new Date(date);
  newDate.setDate(date.getDate() + addDays);
  return newDate;
}
